import { z } from "zod";
import { fuelTypeSchema, vehicleTypeSchema } from "./enums.js";
import { isoDateSchema, odometerSchema } from "./primitives.js";
/** KL 07 AB 1234 / kl-07-ab-1234 all normalise to KL07AB1234. */
export function normalizeRegNumber(input) {
    return input.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
}
export const regNumberSchema = z
    .string()
    .transform(normalizeRegNumber)
    .refine((v) => /^[A-Z0-9]{4,12}$/.test(v), "That does not look like a registration number");
export const vehicleInputSchema = z.object({
    regNumber: regNumberSchema,
    nickname: z.string().trim().max(60).optional(),
    type: vehicleTypeSchema,
    make: z.string().trim().max(60).optional(),
    model: z.string().trim().max(60).optional(),
    variant: z.string().trim().max(60).optional(),
    fuel: fuelTypeSchema.optional(),
    year: z.coerce.number().int().min(1950).max(2100).optional(),
    purchaseDate: isoDateSchema.optional(),
    odometerKm: odometerSchema.optional(),
    insurer: z.string().trim().max(80).optional(),
    policyNo: z.string().trim().max(60).optional(),
    insuranceExpiry: isoDateSchema.optional(),
    pucExpiry: isoDateSchema.optional(),
    fitnessExpiry: isoDateSchema.optional(),
});
export const vehicleUpdateSchema = vehicleInputSchema.partial();
export const rcLookupSchema = z.object({ regNumber: regNumberSchema });
//# sourceMappingURL=vehicle.js.map